import { Editor } from 'slate';
import { isEmptyNode } from './isEmptyNode';

export function isEmptyDocument(editor: Editor): boolean {
  return editor.children.every((element, i) => isEmptyNode(editor, [i]));
}
